<template>
  <div class="navbar-item has-dropdown is-hoverable has-shadow">
    <a class="navbar-link">
      <div class="user-tile has-text-grey">
        <div style="line-height: 1;">
          {{ user.email }}
        </div>
      </div>
    </a>

    <div class="navbar-dropdown is-right">
      <a class="navbar-item" :href="accountUrl" style="padding: 1rem 1.5rem">
        <span>Account</span>
      </a>

      <a class="navbar-item" :href="logoutUrl" style="padding: 1rem 1.5rem">
        <span>Logout</span>
      </a>
    </div>
  </div>
</template>

<script>
import i18n from "./../i18n";
import config from '@/config';

export default {
  i18n,

  props: ["user"],

  computed: {
    accountUrl() {
      return `${config.iam.url}/realms/${config.iam.realm}/account/#/personal-info`;
    },

    logoutUrl() {
      return `${config.iam.url}/realms/${config.iam.realm}/protocol/openid-connect/logout`
    }
  }
};
</script>
